module.exports = __webpack_public_path__ + "static/img/demo-4.3fe5a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/demo-4.png
// module id = lML/
// module chunks = 1